"use client";

import styles from "@/styles/gallery-images.module.css";
import LightGallery from "lightgallery/react";
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-thumbnail.css";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import Image from "next/image";
import image01 from "@/public/mock_images/image_01.webp";
import image02 from "@/public/mock_images/image_02.webp";
import image03 from "@/public/mock_images/image_03.webp";
import image04 from "@/public/mock_images/image_04.webp";
import image05 from "@/public/mock_images/image_05.webp";
import image06 from "@/public/mock_images/image_06.webp";
import image07 from "@/public/mock_images/image_07.webp";
import image08 from "@/public/mock_images/image_08.webp";
import image09 from "@/public/mock_images/image_09.webp";
import image10 from "@/public/mock_images/image_10.webp";
import image11 from "@/public/mock_images/image_11.webp";
import image12 from "@/public/mock_images/image_12.webp";
import image13 from "@/public/mock_images/image_13.webp";
import { useGalleryImages } from "@/hooks/use-gallery-images";
import { cn } from "@/lib/utils";
import { sizesFor } from "@/utils/calculate-image-size";
import type { Image as ImageType } from "@/types/image.types";

const images: ImageType[] = [
  { src: image01, category: 0 },
  { src: image02, category: 2 },
  { src: image03, category: 3 },
  { src: image04, category: 5 },
  { src: image05, category: 8 },
  { src: image06, category: 9 },
  { src: image07, category: 5 },
  { src: image08, category: 5 },
  { src: image09, category: 7 },
  { src: image11, category: 2 },
  { src: image10, category: 5 },
  { src: image12, category: 1 },
  { src: image13, category: 4 },
  { src: image12, category: 6 },
];

export function MainGallery() {
  const chunkedImages = useGalleryImages(images);

  return (
    <LightGallery
      selector=".gallery-item"
      zoomFromOrigin={false}
      startAnimationDuration={0}
      plugins={[lgThumbnail]}
      thumbnail={true}
      backdropDuration={0}
    >
      {chunkedImages.map((images: ImageType[], chunkIndex: number) => (
        <div
          className={cn(
            styles["gallery-chunk"],
            chunkIndex % 2 === 0
              ? styles["gallery-chunk-even"]
              : styles["gallery-chunk-odd"]
          )}
          data-chunk-length={images.length}
          key={`chunk-image-${chunkIndex + 1}`}
          data-header-theme="dark"
        >
          {images.map((image, imageIndex) => (
            <a
              className={cn(
                "gallery-item relative w-full overflow-hidden group",
                styles[`image-${imageIndex}`]
              )}
              href={typeof image.src === "string" ? image.src : image.src.src}
              key={`image-${imageIndex + 1}`}
              aria-label={image.alt || "Open image in lightbox"}
            >
              <Image
                alt=""
                className="object-cover object-center"
                fill
                loading={
                  chunkIndex === 0 && imageIndex === 0 ? "eager" : "lazy"
                }
                priority={chunkIndex === 0 && imageIndex === 0}
                sizes={sizesFor(imageIndex, images.length)}
                src={image.src}
                placeholder="blur"
              />

              <div className="absolute inset-0 bg-gradient-to-t from-brand-950/30 to-brand-900/15 opacity-0 group-hover:opacity-100 transition-all ease-in-out" />
            </a>
          ))}
        </div>
      ))}
    </LightGallery>
  );
}
